// extracted by mini-css-extract-plugin
export default {"textAreaController":"TextArea_textAreaController__OBYcK","formContainer":"TextArea_formContainer__2qkrX","notiText":"TextArea_notiText__ae+5+"};